import React, { useRef, useState } from "react";
import CommonButton from "../Components/CommonButton";
import { lightTheme } from "../Constants/Colors";
import { subHeading1, subHeading2 } from "../Constants/Fonts";
import '.././styles/settings.scss';

function CompanyProfile() {
    const fileInputRef = useRef(null);
    const [previewSrc, setPreviewSrc] = useState(null);

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            const url = URL.createObjectURL(file);
            setPreviewSrc(url);
            // If you need to upload, add logic here
        }
    };

    const getCompanyName = localStorage.getItem("email");

    const getFormattedDomain = () => {
        if (getCompanyName && getCompanyName.includes('@')) {
            const domain = getCompanyName.split('@')[1].split('.')[0];
            return domain.charAt(0).toUpperCase() + domain.slice(1);
        }
        return '';
    };
   
    const companyName = getFormattedDomain();
    const customerCode = "0";
    const companyStatus = "Freemium";
    const expectedDeviceCount = 0;
    const memberDomainsCount = 0;
    const numberOfEmployees = 0;

    return (
        <div>
            <div className='d-flex gap-3 mb-3 align-items-center'>
                <img src='https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/external-attack-surface-scan.svg' alt='external-attack-surface-scan' height={32} width={32} />
                <h3 className='mb-0' style={subHeading1({ color: lightTheme.textPrimary })}>Company Profile</h3>
            </div>
            <div className="companyProfileContainer">

                <section className="companyProfile">

                    <div className="wrp_img_upload">
                        <input
                            type="file"
                            accept="image/*"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                        <div className="upload">
                            <div className="placeholder" onClick={handleButtonClick}>
                                {previewSrc ? (
                                    <img className="preview" src={previewSrc} alt="company logo preview" />
                                ) : (
                                    <img
                                        className="plus"
                                        src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/add_photo_alternate.png"
                                        alt="add alternative"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between flex-column">
                            <p className="mb-0 color_light_blue font_10 font_400">Remove</p>
                            <div className="d-flex gap-1 flex-column align-items-start">
                                <CommonButton
                                    variant="secondary"
                                    onClick={handleButtonClick}
                                    text={
                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                            <img src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/upload-company-logo.svg" alt="upload icon" height={14} width={12} style={{ filter: 'brightness(0) invert(28%)' }} /> Upload Company Logo
                                        </span>
                                    }
                                />
                                <p className="mb-0 color_light_blue font_14 font_400">Max image size 800kbs</p>
                            </div>

                        </div>

                    </div>
                    <div className="infoGrid border_top">
                        <div>
                            <div className="label">Company Name</div>
                            <div className="value">{companyName}</div>
                        </div>
                        <div>
                            <div className="label">Customer ID</div>
                            <div className="value">{customerCode}</div>
                        </div>
                        <div>
                            <div className="label">Number Of Employees</div>
                            <div className="value">{numberOfEmployees}</div>
                        </div>
                        <div>
                            <div className="label">Expected Device</div>
                            <div className="value">{expectedDeviceCount}</div>
                        </div>
                        <div>
                            <div className="label">Member Domains</div>
                            <div className="value">
                                {memberDomainsCount}{" "}
                                <a href="#domains" className="link">
                                    View all domains
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="label">Company Status</div>
                            <div className="value">{companyStatus}</div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default CompanyProfile;



